<template>
  <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
    <vs-col type="flex"  vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
    <vs-card class=" mb-0">
      <div slot="header">
        <h3 class="mb-1">Login Here</h3>
        <p class="mb-0">Welcome back, please login to your account.</p>
      </div>
      <vs-alert v-if="errors.length" class="mb-3 mt-1" color="danger" :active="!loginDataChanged">
        <b>Please correct the following error(s):</b>
        <ul class="common-list">
          <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
        </ul>
      </vs-alert>
      <form @submit="checkForm" novalidate="true">

      <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" icon="person" placeholder="Email ID" v-model="email" type="email"/>
      <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 vs-input-large" type="password" icon="lock" placeholder="Password" v-model="password"/>
      <div class="d-flex pt-3 pb-3">
          <vs-checkbox v-model="rememberme">Remember me?</vs-checkbox>
          <router-link to="/site/forgotpassword" class="ml-auto">Forgot Password? </router-link>
      </div>
      <input class="btn-block btn btn-primary submit-button" type="submit" @click.stop.prevent="onSubmit" value="Login"/>
    </form>

      <div class="d-flex justify-content-center mt-3">
      Don't have an account?  <router-link class="ml-1" to="/site/register"> Create an Account</router-link>
    </div>


    <hr class="custom-hr" />

      <div class="mt-3">
        <google-button
           :on-logged-in="onSignInSuccess"
           :on-failed="onSignInError"
        ></google-button>
      </div>

    </vs-card>
    </vs-col>
  </vs-row>

</template>

<script>
import { AuthService } from './../../services/auth.service'
import GoogleButton from "../../components/google-button/GoogleButton";
import NProgress from 'nprogress';

export default {
  name: 'Login',
  components: {GoogleButton},
  data:()=>({
    rememberme:false,
    email:'',
    password:'',
    errors:[],
    loginDataChanged: false
  }),
  methods:{
    onSignInSuccess (googleUser) {
      NProgress.start();
      this.$vs.notify({
        color: "success",
        title: 'Success!',
        text: 'Authorized successfully'
      });

      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const profile = googleUser.getAuthResponse(true) // etc etc
      AuthService.makeSocial(profile)
        .then( () => {
            this.$store.dispatch('user/GET')
                .then(() => this.$router.push('/'))
                .catch( error => error.alert());
        })
        .catch( error => {
          NProgress.done();
          error.alert()
        });
    },
    onSignInError () {
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'Can\'t connect to Google service'
      });
    },

    changeLoginData: function(e){
      if (e.key !== 'Enter') {
        this.loginDataChanged = true;
      }
    },

    onSubmit: function(e){
      if (this.checkForm(e)) {
        this.sendLogin();
      } else {
        e.preventDefault();
      }
    },

    sendLogin: function(){
      this.errors = [];
      NProgress.start();

      AuthService.makeLogin({
        username: this.email,
        password: this.password,
        rememberme: this.rememberme
      })
      .then(() => {
        this.$store.dispatch('user/GET')
          .then(() => this.$router.push('/'))
          .catch( error => error.alert());
      })
      .catch( error => {
        NProgress.done();
        this.errors = error.apply()
      });
    },

    checkForm:function() {
      this.errors = [];
      if(!this.email) {
        this.errors.push("Email required.");
      } else if(!this.validEmail(this.email)) {
        this.errors.push("Valid email required.");
      } else if(!this.password) {
        this.errors.push("Password required.");
      }
      this.loginDataChanged = false;
      return this.errors.length===0;
    },

    /* eslint-disable */
    validEmail:function(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    }
    /* eslint-enable */
  }
}
</script>

<style>
.login-register-bg{
  margin:0 auto;
  background:url(../../assets/images/background/auth-bg.jpg) no-repeat center center;
}
.login-register-box{
  max-width:400px;
}
</style>

